import React, {Component} from "react";
import {Layout, Table, Divider, Modal, Form, Input, Pagination, Button, Select, message, Switch} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './teacher.less'
import '../../assets/css/admin.less'
import {
    reqAddTeacher,
    reqDeleteStudent,
    reqDepartmentList, reqDisableStudent,
    reqEditTeacher, reqEnableStudent,
    reqTeacherList,resetTeacherPwd
} from "../../api";

const {Content} = Layout;
const { Option } = Select;

/**
 * 教师管理路由组件
 */
export class Teacher extends Component {

    state = {
        ModalText: '',
        visible: false,
        confirmLoading: false,
        confirmDirty: false,
        autoCompleteResult: [],
        teacher:{},
        teacherList:[],
        selectValue:'',
        total:0,
        page:1,
        size:10,
        fuzzyName:'',
        deleteVisible:false,
        departmentList:[],
        did:1,
        deleteId:'',
        deleteName:'',
        selectedRowKeys: [],
        setRecord:{},
        setVisible:false,
        selectStatus:'',
        upvisible:"",
        recordId:""

    };

    showEditModal = (record) => {
        const teacher = {
            id:record.id,
            userName:record.userName,
            passwd:record.passwd,
            name:record.name,
            mobile:record.mobile,
            email:record.email,
            departmentId:record.departmentId,
            departmentName:record.departmentName
        };
        this.setState({
            visible: true,
            ModalText:'修改教师',
            teacher:teacher
        });
    };

    updatePwd = (record) => {
        this.setState({
            upvisible: true,
            pwd: '',
            pwd1: '',
            recordId:record.id
        });
    };

    showAddModal = () => {
        this.setState({
            visible: true,
            ModalText:'添加教师',
            teacher:{}
        });
    };

    handleOk = (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        /* if(this.state.ModalText==='修改教师'){
            values.passwd = 'pwd'
        } */
        this.props.form.validateFields(async(err, values) => {
            if (!err) {
                if(values.departmentId.indexOf("|") === -1){
                    values["departmentId"] = this.state.teacher.departmentId
                }else {
                    let arr = values.departmentId.split("|");
                    values["departmentId"] = arr[0];
                    values["departmentName"] = arr[1];
                }
                if(this.state.ModalText==='添加教师'){
                    const result = await reqAddTeacher(values.departmentId,values);
                    if(result.code === '000000') {
                        this.getTeacherList({
                            page: this.state.page,
                            size: 10
                        });
                        message.success("添加成功");
                        this.handleCancel();
                    }else{
                        message.error("添加失败");
                    }
                }else if(this.state.ModalText==='修改教师'){
                    console.log(values);
                    const result = await reqEditTeacher(values.departmentId,values.id,values);
                    if(result.code === '000000') {
                        this.getTeacherList({
                            page: this.state.page,
                            size: 10
                        });
                        message.success("修改成功");
                        this.handleCancel();
                    }else {
                        message.error(result.data.msg);
                    }
                }
            }
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible:false,
            deleteId:'',
            deleteName:'',
            selectedRowKeys:[],
            confirmLoading: false,
            setVisible:false,
            upvisible:false
        });
    };

    getTeacherList = async (data) =>{
        const result = await reqTeacherList(data);
        if(result.code === '000000') {
            this.setState({
                teacherList:result.data.rows,
                page:result.data.page,
                total:result.data.total
            })
        }else {
            message.error(result.data.msg);
        }
    };

    getDepartmentList = async (page,size) =>{
        const result = await reqDepartmentList(page,size);
        if(result.code === '000000') {
            this.setState({
                departmentList:result.data.rows
            })
        }else {
            message.error(result.msg);
        }
    };

    showDeleteModal =(record,type)=> {
        if(type==='删除') {
            this.setState({
                deleteId:record.id,
                deleteName:record.name,
                deleteVisible:true
            })
        }else {
            if(this.state.deleteId===''){
                message.info("没有选中行");
            }else {
                this.setState({
                    deleteVisible:true
                })
            }
        }
    };

    handleupOk = async() => {
        let password = document.getElementById("password11").value;
        let confirm = document.getElementById("confirm").value;
        // let senha = document.getElementsByName('senha').value;
        // let senha2 = document.getElementsByName('senha2').value;
        // console.log(password);
        // console.log(confirm);
        if (password && confirm) {
            if (password === confirm) {
                // let data = new FormData();
                // data.append("pwd", password);
                // data.append("token", this.state.token);
                const result = await resetTeacherPwd(this.state.recordId,password);
                if (result.code === '000000') {
                    message.success("修改密码成功");
                    this.setState({
                        upvisible: false
                    });
                    // this.props.history.replace("/login");
                }
            } else {
                message.error("两次密码不一致")
            }
        } else {
            message.error("请输入密码")
        }

    }

    deleteTeacher = async (ids,e) => {
        const result = await reqDeleteStudent(ids);
        if(result.code==='000000'){
            message.success("删除成功");
            this.getTeacherList({
                page:1,
                size:10
            });
            this.handleCancel();
        }
    };

    showSetModal = (record) =>{
        const setRecord = {
            id:record.id,
            userName:record.userName,
            passwd:record.passwd,
            name:record.name,
            mobile:record.mobile,
            email:record.email,
            departmentId:record.departmentId,
            departmentName:record.departmentName,
            status:record.status
        };
        this.setState({
            setRecord : setRecord,
            setVisible : true
        })
    };

    selectChange = e =>{
        this.setState({
            selectValue:e
        })
    };

    selectStatus = e => {
        this.setState({
            selectStatus: e
        })
    };

    searchList = async() => {
        const name = document.getElementById("search_input").value;
        let data={
            page:1,
            size:10,
        };
        if(this.state.selectValue!==''&&this.state.selectValue!==0){
            data["departmentId"] = this.state.selectValue
        }
        if(name!==''){
            data["fuzzyName"]=name;
                this.setState({
                    fuzzyName:name
                })
        }
        if (this.state.selectStatus !== '' && this.state.selectStatus !== 0) {
            data["status"] = this.state.selectStatus
        }
        this.getTeacherList(data);
    };

    clearSearch = async() => {
        window.location.reload();
    };

    pageClick = async page => {
        let data = {
            page:page,
            size:10,
        };
        if(this.state.selectValue!==''&&this.state.selectValue!==0){
            data["departmentId"] = this.state.selectValue
        }
        if(this.state.fuzzyName!==''){
            data["fuzzyName"] = this.state.fuzzyName;
        }
        if (this.state.selectStatus !== '' && this.state.selectStatus !== 0) {
            data["status"] = this.state.selectStatus
        }
        this.getTeacherList(data);
    };

    itemRender =(current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total)=>{
        return '共'+total+'条记录/每页'+this.state.size+'条';
    };

    setTeacher= async (record) => {
        let data = record;
        data["status"] = !record.status;
        const result = await reqEditTeacher(record.departmentId,record.id,data);
        if(result.code === '000000') {
            this.searchList();
            message.success("修改成功");
        }else {
            message.error(result.data.msg);
        }
        this.handleCancel();
    };

    componentDidMount=async()=>{
        sessionStorage.clear();
        this.getTeacherList({
            page:1,
            size:10
        });
        this.getDepartmentList({
            page:1,
            size:100
        });
        document.getElementsByClassName("ant-menu-item")[8].click();
    };

    render (){

        const { getFieldDecorator } = this.props.form;
        const { total,page,visible, size,deleteVisible,upvisible,selectedRowKeys,deleteId,deleteName,departmentList,confirmLoading, ModalText ,teacherList,setVisible,setRecord} = this.state;

        const columns = [
        {
            title: '用户名/工号',
            dataIndex: 'userName',
            key: 'userName',
            align:'center',
        },
        {
            title: '院系名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
            align:'center',
        },
        /* {
            title: '密码',
            dataIndex: 'passwd',
            key: 'passwd',
        }, */
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            align:'center',
        },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                align:'center',
                render: (text, record) => (
                    <span>
                        <Switch checked={record.status} onChange={this.showSetModal.bind(this,record)} checkedChildren="启用" unCheckedChildren="禁用" defaultChecked />
                </span>
                ),
            },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => (
                <span>
                    <a onClick={this.showEditModal.bind(this,record)}>编辑 | </a>
                    <a onClick={this.updatePwd.bind(this, record)}>重置密码</a>
                    {/*<Divider type="vertical" />
                    <a onClick={this.showDeleteModal.bind(this,record,'删除')}>删除</a>*/}
                </span>
            ),
        },
    ];

        /* const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    name.push(selectedRows[i].name)
                }
                this.setState({
                    deleteId:selectedRowKeys.toString(),
                    deleteName:name.toString(),
                    selectedRowKeys:selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        }; */

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right'>
                            <div className='table_search'>
                                {/*<Button className='batch_delete' onClick={this.showDeleteModal.bind(this,deleteId,'批量删除')}>批量删除</Button>*/}
                                <Button className="batch_delete" onClick={this.showAddModal}>添加教师</Button>
                                <Button className='batch_delete clear' onClick={this.clearSearch.bind(this)}>重置</Button>
                                <Button className='batch_delete search' onClick={this.searchList.bind(this)}>检索</Button>
                                <div className='search_box' >
                                    <label>教师姓名</label>
                                    <Input id='search_input' className="search_name" style={{width:160}} />
                                </div>
                                <div className='search_box'>
                                    <label>院系</label>
                                    <Select id='search_select' style={{width: 160}}
                                        optionFilterProp="children"
                                        onChange={this.selectChange.bind(this)}>
                                        <Option key={0} value=''>全部</Option>
                                        {
                                            departmentList&&departmentList.map((item, index) => (
                                                <Option key={index} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                                <div className='search_box'>
                                    <label>状态</label>
                                    <Select id='search_select'
                                            style={{width: 160}}
                                            onChange={this.selectStatus.bind(this)}>
                                        <Option key={0} value={0}>全部</Option>
                                        <Option key={1} value={'true'}>正常</Option>
                                        <Option key={2} value={'false'}>禁用</Option>
                                    </Select>
                                </div>
                            </div>
                            {/* <Table rowSelection={rowSelection} columns={columns} pagination={false} */}
                            <Table columns={columns} pagination={false}
                                   dataSource={teacherList} rowKey={teacherList => teacherList.id}/>
                            <Pagination total={total} current={page} pageSize={size} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <Modal title={ModalText} visible={visible} onOk={this.handleOk} confirmLoading={confirmLoading} onCancel={this.handleCancel}
                               okText="确认" cancelText="取消" destroyOnClose='true'>
                            <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue:this.state.teacher.id,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item label="用户名">
                                    {getFieldDecorator('userName', {
                                        initialValue:this.state.teacher.userName,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入用户名!',
                                            },
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                                <Form.Item label="密码" hasFeedback style={{display: ModalText === "添加教师" ? 'block' : 'none'}}>
                                    {getFieldDecorator('passwd', {
                                        initialValue:this.state.teacher.passwd,
                                        rules: [
                                            {
                                                required: ModalText === "添加教师" ? true : false,
                                                message: '请输入密码!',
                                            },
                                        ],
                                    })(<Input.Password autoComplete={"off"}/>)}
                                </Form.Item>
                                <Form.Item label="姓名">
                                    {getFieldDecorator('name', {
                                        initialValue:this.state.teacher.name,
                                        rules: [{ required: true, message: '请输入姓名!' }],
                                    })(<Input />)}
                                </Form.Item>
                                <Form.Item label="手机号">
                                    {getFieldDecorator('mobile', {
                                        initialValue:this.state.teacher.mobile,
                                        validate: [
                                            // 在onBlur时，触发两个对象中的规则
                                            {
                                                trigger: "onBlur",
                                                rules: [
                                                    {
                                                        pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                                                        message: '请输入正确的手机号',
                                                    },
                                                    { required: true, message: '请输入手机号!' }],
                                            },
                                        ]
                                    })(<Input />)}
                                </Form.Item>
                                <Form.Item label="邮箱">
                                    {getFieldDecorator('email', {
                                        initialValue:this.state.teacher.email,
                                        validate: [
                                            // 在onBlur时，触发两个对象中的规则
                                            {
                                                trigger: "onBlur",
                                                rules: [
                                                    {
                                                        type: 'email',
                                                        message: '邮箱格式错误',
                                                    },
                                                    {
                                                        required: true,
                                                        message: '请输入邮箱',
                                                    },
                                                ],
                                            },
                                        ]
                                    })(<Input />)}
                                </Form.Item>
                                <Form.Item label="院系">
                                    {getFieldDecorator('departmentId', {
                                        initialValue: this.state.teacher.departmentName,
                                        rules: [{required: true, message: '请选择院系'}],
                                    })(
                                        <Select>
                                            {
                                                departmentList&&departmentList.map((item, index) => (
                                                    <Option key={index}
                                                            value={item.id + "|" + item.name}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal title='重置密码' visible={upvisible} onOk={this.handleupOk} confirmLoading={confirmLoading}
                            onCancel={this.handleCancel}
                            okText="确认" cancelText="取消" destroyOnClose='true'>
                             <Form {...formItemLayout}>
                                <Form.Item label="密码" >
                                    <Input.Password id='password11' autoComplete={"off"} placeholder='请输入新密码'/>
                                </Form.Item>
                                <Form.Item label="确认密码" >
                                    <Input.Password id='confirm' autoComplete={"off"} placeholder='请确认密码' />
                                </Form.Item>
                            </Form>
                            {/* <div className='password'>
                                <div className='item'>
                                    <span className='item_span'>新密码：</span><Input.Password autoComplete={"off"} placeholder='请输入新密码' id='password11' />
                                </div>
                                <div className='item'>
                                    <span className='item_span'>确认新密码：</span><Input.Password autoComplete={"off"} placeholder='请输入新密码' id='confirm' />
                                </div>
                            </div> */}
                        </Modal>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteTeacher.bind(this,deleteId)}
                            onCancel={this.handleCancel}>
                            <div>确定删除吗？</div>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={setVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.setTeacher.bind(this, setRecord)}
                            onCancel={this.handleCancel}>
                            <div>确认修改{setRecord.userName}的状态吗？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapTeacher = Form.create()(Teacher);
export default WrapTeacher;